import { knbrQuote } from './kn-br-quotes.i18n';

export const en = { knbrQuote };
